import { render, staticRenderFns } from "./NuevoSram.vue?vue&type=template&id=7b5f340d&"
import script from "./NuevoSram.vue?vue&type=script&lang=js&"
export * from "./NuevoSram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports